// extracted by mini-css-extract-plugin
export var cardService = "CardTwo-module--card-service--490Le";
export var cardService__index = "CardTwo-module--card-service__index--1jDFt";
export var cardService__bg = "CardTwo-module--card-service__bg--2mbKW";
export var cardService__header = "CardTwo-module--card-service__header--1ahYl";
export var cardService__desc = "CardTwo-module--card-service__desc--31KOE";
export var cardService__link = "CardTwo-module--card-service__link--2HQmd";